<template>
  <div>

    <progress-bar :show="isLoading"></progress-bar>

    <v-layout
      row
      wrap
    >
      <v-flex>
        <h2 class="display-1 mt-4 ml-4">Meine Nachrichten {{ neuenachrichten }}</h2>
      </v-flex>
      <v-flex style="text-align: right;">
        <v-btn
          class="mt-4 ml-4"
          flat
          @click="vuexnachrichten"
        >
          <v-icon left>refresh</v-icon>Aktualisieren
        </v-btn>
      </v-flex>
    </v-layout>

    <v-container
      fluid
      style="height: 100%;"
      grid-list-lg
    >
      <v-layout
        class=""
        style="xborder: 1px solid red;"
        wrap
      >
        <v-flex
          xs12
          md3
        >
          <v-card>
            <v-card-text class="ma-0 pa-0">
              <v-flex class="ma-0 pa-0">
                <span v-if="this.$store.getters.fetchNachrichten">
                  <nachrichten-threads
                    :threads="this.$store.getters.fetchNachrichten"
                    v-on:threadselect="thread = $event"
                    :current="thread"
                    v-on:threadgeloescht="vuexnachrichten()"
                  >
                    >
                  </nachrichten-threads>
                </span>

                <p
                  v-if="this.$store.getters.fetchNachrichten.length < 1"
                  class="pa-5"
                >Keine Nachrichten vorhanden</p>
              </v-flex>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex
          xs12
          md9
        >
          <v-card>
            <v-card-text>
              <v-flex class="chat-container">

                <nachrichten-content
                  v-if="this.threaddata"
                  :thread="this.threaddata"
                  v-on:nachrichtgesendet="fetchThread()"
                  v-on:threadgeloescht="threadgeloescht()"
                >
                  ></nachrichten-content>

                <span
                  v-else
                  class="title"
                >Bitte eine Konversation wählen..</span>

              </v-flex>
            </v-card-text>
          </v-card>
        </v-flex>

      </v-layout>

    </v-container>

    <!-- <v-btn @click="vuexnachrichten">vuex fetch</v-btn> -->

    <!-- <v-btn @click="fetchNeue">Posts?</v-btn> -->

  </div>
</template>

<script>
// import { mapGetters } from 'vuex'

import NachrichtenThreads from '~/components/nachrichten/NachrichtenThreads.vue'
import NachrichtenContent from '~/components/nachrichten/NachrichtenContent.vue'

export default {
  components: {
    // StripePay,

    // MailSend,
    NachrichtenThreads,
    NachrichtenContent
  },

  // name: 'home-view',
  metaInfo () {
    return { title: 'Meine Nachrichten' }
  },
  watch: {
    thread: 'fetchThread'
  },
  mounted: function () {
    //  this.fetchData();

    this.vuexnachrichten()

    this.isLoading = false
    // var interval = setInterval(function () {
    //    this.intervaltest();
    //  }.bind(this), 10000);

    //  this.interval = setInterval(this.intervaltest, 12000)
  },
  methods: {
    threadgeloescht () {
      this.threaddata = ''
      this.vuexnachrichten()
    },
    async vuexnachrichten () {
      const data = await this.$store.dispatch('fetchNachrichten')
    },

    // fetchData () {
    //   this.isLoading = true
    //     let self = this;
    //       axios.get('/api/v1/nachrichten')
    //       .then(resp => {
    //         self.nachrichten = resp.data;
    //       console.log(self.nachrichten)
    //       })
    //       .catch(err => {
    //         console.log(err)

    //       })
    //       .finally(() => (this.isLoading = false))
    // },
    fetchNeue () {
      const self = this
      axios
        .get('/api/v1/nachrichtencount')
        .then(resp => {
          self.neuenachrichten = resp.data
          console.log(self.neuenachrichten)
        })
        .catch(err => {
          console.log(err)
        })
    },
    fetchThread () {
      this.isLoading = true
      const self = this
      axios
        .get('/api/v1/nachrichten/' + this.thread)
        .then(resp => {
          self.threaddata = resp.data
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => (this.isLoading = false))
    },
    consoleLog () {
      console.log('event ausgeführt')
    }
  },
  beforeDestroy: function () {
    console.log('Stopping the interval timer')
    clearInterval(this.interval)
  },

  created () {},
  data: function () {
    return {
      neuenachrichten: '',
      premiumloading: true,
      nachrichten: {
        data: ''
      },
      current: '',
      isLoading: true,
      page: 3,
      thread: null,
      threaddata: ''
      // name: '',
    }
  }
}
</script>
<style>
.chat-container {
  /* box-sizing: border-box; */
  min-height: calc(100vh - 18rem);
  overflow-y: auto;
}
</style>



